export interface CardDetailModel {
  title: string;
  value: string | number;
  currency?: boolean;
}
